module.exports = __webpack_public_path__ + "static/media/bus.58e935f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/bus.png
// module id = 1945
// module chunks = 0